"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tokens_1 = require("../tokens");
exports.NumberBuildInFunctions = {
    int: {
        function: (obj) => {
            return {
                name: tokens_1.LiteralTokens.NumberLiteral,
                image: parseInt(String(obj[0].image), 10),
            };
        },
        arguments: ['obj'],
    },
    abs: {
        function: (obj) => {
            if (!Number.isFinite(obj[0].image))
                throw new Error('数値ではありません。');
            return {
                name: tokens_1.LiteralTokens.NumberLiteral,
                image: Math.abs(obj[0].image),
            };
        },
        arguments: ['obj'],
    },
};
